"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _questproject_formCreate = _interopRequireDefault(require("./queries/uberadmin/questproject_formCreate.graphql"));
var _questproject_formEdit = _interopRequireDefault(require("./queries/uberadmin/questproject_formEdit.graphql"));
var _questproject_tableArchived = _interopRequireDefault(require("./queries/uberadmin/questproject_tableArchived.graphql"));
var _questproject_tableMain = _interopRequireDefault(require("./queries/uberadmin/questproject_tableMain.graphql"));
var _questprojectadmin_formEdit = _interopRequireDefault(require("./queries/uberadmin/questprojectadmin_formEdit.graphql"));
var _questprojectadmin_tableArchived = _interopRequireDefault(require("./queries/uberadmin/questprojectadmin_tableArchived.graphql"));
var _questprojectadmin_tableMain = _interopRequireDefault(require("./queries/uberadmin/questprojectadmin_tableMain.graphql"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = {
  pageTitle: 'Manage Organizations',
  pageDescription: '',
  tabWidths: {
    left: 2,
    right: 10
  },
  verticalNavClass: 'triangleNav',
  verticalNav: [{
    handle: 'admin_manage_projects',
    label: '@groupType:many:questproject@',
    order: 0,
    contentConfig: {
      type: '@groupType:one:questproject@',
      nexusType: 'group',
      routes: {
        create: {
          name: 'api.nexus.group.store'
        },
        edit: {
          name: 'api.nexus.group.update',
          params: {
            group: 'group.groupId'
          }
        },
        "delete": {
          name: 'api.nexus.group.destroy',
          params: {
            group: 'group.groupId'
          }
        }
      },
      form: {
        handle: 'admin_manage_questprojects_form',
        graphql: {
          create: {
            gql_query: _questproject_formCreate["default"]
          },
          edit: {
            gql_query: _questproject_formEdit["default"],
            requiredVariables: [{
              variable: 'groupId',
              field: 'group.groupId'
            }]
          }
        },
        fields: [{
          handle: 'questproject_questorg',
          reduxFieldHandle: 'parent',
          order: 0,
          type: 'pawnDataField',
          validationSettings: {
            isRequired: true
          },
          displaySettings: {
            renderAs: 'table',
            label: '@groupType:one:questorganization@:',
            fieldProps: {
              selectionType: 'single',
              setValueNotArray: true,
              query: 'query { groups(as: uberadmin) { questorganizationList { group { groupId label} fields { level }}}}',
              dataPath: 'groups.questorganizationList',
              table: {
                props: {
                  name: 'uberadmin_manage_questproject_form_group',
                  rowKey: 'group.groupId',
                  saveState: true
                },
                columns: [{
                  name: 'group.label',
                  label: '@groupType:one:questorganization@',
                  filter: true,
                  sort: true
                }, {
                  name: 'fields.level',
                  label: 'Level',
                  filter: true,
                  sort: true
                }]
              }
            }
          },
          graphql: {
            dependsOn: null,
            edit: {
              valuePath: 'groups.questproject.ancestorGroups.questorganization.group.groupId',
              skipPawnCollectionProcessing: true
            }
          }
        }, {
          handle: 'questprojectlabel_admin',
          reduxFieldHandle: 'label',
          order: 1,
          type: 'pawnDataField',
          validationSettings: {
            validationType: 'ascii',
            isRequired: true
          },
          displaySettings: {
            renderAs: 'input',
            label: '@groupType:one:questproject@ Name:',
            fieldProps: {
              initialValue: ''
            }
          },
          graphql: {
            dependsOn: null,
            edit: {
              valuePath: 'groups.questproject.group.label'
            }
          }
        }, {
          handle: 'questproject_field_1_admin',
          reduxFieldHandle: 'field_1',
          order: 2,
          type: 'pawnDataField',
          validationSettings: {
            validationType: 'ascii',
            isRequired: false
          },
          displaySettings: {
            renderAs: 'input',
            label: 'Respondent Field 1 Label:',
            fieldProps: {
              initialValue: ''
            }
          },
          graphql: {
            dependsOn: null,
            edit: {
              valuePath: 'groups.questproject.fields.field_1'
            }
          }
        }, {
          handle: 'questproject_field_1_is_identifiable_admin',
          reduxFieldHandle: 'field_1_is_identifiable',
          order: 3,
          type: 'pawnDataField',
          validationSettings: {
            isRequired: false
          },
          displaySettings: {
            renderAs: 'checkbox',
            label: 'Respondent Field 1 is identifiable',
            fieldProps: {
              initialValue: false
            }
          },
          graphql: {
            dependsOn: null,
            edit: {
              valuePath: 'groups.questproject.fields.field_1_is_identifiable'
            }
          }
        }, {
          handle: 'questproject_field_2_admin',
          reduxFieldHandle: 'field_2',
          order: 4,
          type: 'pawnDataField',
          validationSettings: {
            validationType: 'ascii',
            isRequired: false
          },
          displaySettings: {
            renderAs: 'input',
            label: 'Respondent Field 2 Label:',
            fieldProps: {
              initialValue: ''
            }
          },
          graphql: {
            dependsOn: null,
            edit: {
              valuePath: 'groups.questproject.fields.field_2'
            }
          }
        }, {
          handle: 'questproject_field_2_is_identifiable_admin',
          reduxFieldHandle: 'field_2_is_identifiable',
          order: 5,
          type: 'pawnDataField',
          validationSettings: {
            isRequired: false
          },
          displaySettings: {
            renderAs: 'checkbox',
            label: 'Respondent Field 2 is identifiable',
            fieldProps: {
              initialValue: false
            }
          },
          graphql: {
            dependsOn: null,
            edit: {
              valuePath: 'groups.questproject.fields.field_2_is_identifiable'
            }
          }
        }, {
          handle: 'questproject_field_3_admin',
          reduxFieldHandle: 'field_3',
          order: 6,
          type: 'pawnDataField',
          validationSettings: {
            validationType: 'ascii',
            isRequired: false
          },
          displaySettings: {
            renderAs: 'input',
            label: 'Respondent Field 3 Label:',
            fieldProps: {
              initialValue: ''
            }
          },
          graphql: {
            dependsOn: null,
            edit: {
              valuePath: 'groups.questproject.fields.field_3'
            }
          }
        }, {
          handle: 'questproject_field_3_is_identifiable_admin',
          reduxFieldHandle: 'field_3_is_identifiable',
          order: 7,
          type: 'pawnDataField',
          validationSettings: {
            isRequired: false
          },
          displaySettings: {
            renderAs: 'checkbox',
            label: 'Respondent Field 3 is identifiable',
            fieldProps: {
              initialValue: false
            }
          },
          graphql: {
            dependsOn: null,
            edit: {
              valuePath: 'groups.questproject.fields.field_3_is_identifiable'
            }
          }
        }, {
          handle: 'questproject_field_4_admin',
          reduxFieldHandle: 'field_4',
          order: 8,
          type: 'pawnDataField',
          validationSettings: {
            validationType: 'ascii',
            isRequired: false
          },
          displaySettings: {
            renderAs: 'input',
            label: 'Respondent Field 4 Label:',
            fieldProps: {
              initialValue: ''
            }
          },
          graphql: {
            dependsOn: null,
            edit: {
              valuePath: 'groups.questproject.fields.field_4'
            }
          }
        }, {
          handle: 'questproject_field_4_is_identifiable_admin',
          reduxFieldHandle: 'field_4_is_identifiable',
          order: 9,
          type: 'pawnDataField',
          validationSettings: {
            isRequired: false
          },
          displaySettings: {
            renderAs: 'checkbox',
            label: 'Respondent Field 4 is identifiable',
            fieldProps: {
              initialValue: false
            }
          },
          graphql: {
            dependsOn: null,
            edit: {
              valuePath: 'groups.questproject.fields.field_4_is_identifiable'
            }
          }
        }, {
          handle: 'questproject_field_5_admin',
          reduxFieldHandle: 'field_5',
          order: 10,
          type: 'pawnDataField',
          validationSettings: {
            validationType: 'ascii',
            isRequired: false
          },
          displaySettings: {
            renderAs: 'input',
            label: 'Respondent Field 5 Label:',
            fieldProps: {
              initialValue: ''
            }
          },
          graphql: {
            dependsOn: null,
            edit: {
              valuePath: 'groups.questproject.fields.field_5'
            }
          }
        }, {
          handle: 'questproject_field_5_is_identifiable_admin',
          reduxFieldHandle: 'field_5_is_identifiable',
          order: 11,
          type: 'pawnDataField',
          validationSettings: {
            isRequired: false
          },
          displaySettings: {
            renderAs: 'checkbox',
            label: 'Respondent Field 5 is identifiable',
            fieldProps: {
              initialValue: false
            }
          },
          graphql: {
            dependsOn: null,
            edit: {
              valuePath: 'groups.questproject.fields.field_5_is_identifiable'
            }
          }
        }, {
          handle: 'questproject_missing_qual_ne',
          reduxFieldHandle: 'qualitative_neverEncountered',
          order: 12,
          type: 'pawnDataField',
          validationSettings: {
            isRequired: false
          },
          displaySettings: {
            renderAs: 'input',
            label: 'Missing Data Value - Qualitative - Never Encountered:',
            fieldProps: {
              initialValue: ''
            }
          },
          graphql: {
            dependsOn: null,
            edit: {
              valuePath: 'groups.questproject.group.settings.missingValues.qualitative.neverEncountered'
            }
          }
        }, {
          handle: 'questproject_missing_qual_da',
          reduxFieldHandle: 'qualitative_declinedToAnswer',
          order: 13,
          type: 'pawnDataField',
          validationSettings: {
            isRequired: false
          },
          displaySettings: {
            renderAs: 'input',
            label: 'Missing Data Value - Qualitative - Declined To Answer:',
            fieldProps: {
              initialValue: ''
            }
          },
          graphql: {
            dependsOn: null,
            edit: {
              valuePath: 'groups.questproject.group.settings.missingValues.qualitative.declinedToAnswer'
            }
          }
        }, {
          handle: 'questproject_missing_qunt_ne',
          reduxFieldHandle: 'quantitative_neverEncountered',
          order: 14,
          type: 'pawnDataField',
          validationSettings: {
            isRequired: false
          },
          displaySettings: {
            renderAs: 'input',
            label: 'Missing Data Value - Quantitative - Never Encountered:',
            fieldProps: {
              initialValue: ''
            }
          },
          graphql: {
            dependsOn: null,
            edit: {
              valuePath: 'groups.questproject.group.settings.missingValues.quantitative.neverEncountered'
            }
          }
        }, {
          handle: 'questproject_missing_qunt_da',
          reduxFieldHandle: 'quantitative_declinedToAnswer',
          order: 15,
          type: 'pawnDataField',
          validationSettings: {
            isRequired: false
          },
          displaySettings: {
            renderAs: 'input',
            label: 'Missing Data Value - Quantitative - Declined To Answer:',
            fieldProps: {
              initialValue: ''
            }
          },
          graphql: {
            dependsOn: null,
            edit: {
              valuePath: 'groups.questproject.group.settings.missingValues.quantitative.declinedToAnswer'
            }
          }
        }, {
          handle: 'type_questproject',
          reduxFieldHandle: 'type',
          isRequired: true,
          order: 17,
          type: 'pawnDataField',
          validationSettings: {
            validationType: 'ascii',
            isRequired: true
          },
          displaySettings: {
            renderAs: 'hidden',
            fieldProps: {
              initialValue: 'questproject'
            }
          }
        }]
      },
      tableTop: {
        handle: 'dashboard',
        saveState: true,
        views: [{
          handle: 'manage',
          title: 'Manage',
          table: {
            name: 'main',
            rowKey: 'group.groupId',
            query: _questproject_tableMain["default"],
            requiredVariables: [{
              variable: 'pawnId',
              field: 'user.acting.id',
              from: 'user'
            }, {
              variable: 'productId',
              field: 'app.products.productId',
              from: 'redux'
            }],
            rowActions: [{
              action: 'archiveGroups',
              name: 'Archive Selected',
              title: 'Archive Selected'
            }, {
              action: 'deleteGroups',
              name: 'Delete Selected',
              title: 'Delete Selected'
            }],
            columns: [{
              handle: 'actions',
              label: 'Actions',
              name: 'actions',
              renderAs: {
                type: 'RosteringButtons',
                "class": 'html',
                settings: {
                  buttons: [{
                    type: 'edit',
                    label: '',
                    className: 'btn-xs btn-success',
                    withTooltip: true,
                    tooltipText: 'Edit'
                  }, {
                    type: 'archive',
                    label: '',
                    className: 'btn-xs btn-primary',
                    withTooltip: true,
                    tooltipText: 'Archive'
                  }, {
                    type: 'delete',
                    label: '',
                    className: 'btn-xs btn-danger',
                    withTooltip: true,
                    tooltipText: 'Delete'
                  }]
                }
              }
            }, {
              handle: 'questProjectName',
              label: '@groupType:one:questproject@ Name',
              name: 'group.label',
              filter: true,
              sort: true
            }, {
              handle: 'permissions',
              label: 'Permissions',
              name: 'designPawnPerm',
              className: 'text-center',
              renderAs: {
                type: 'Permissions',
                "class": 'html',
                settings: {
                  type: 'questProject'
                }
              }
            }, {
              handle: 'questAdminCount',
              label: 'Permitted @role:many:questprojectadmin@',
              name: 'targetedByPawns.questprojectadminCount',
              filter: true,
              sort: true,
              className: 'text-center',
              renderAs: {
                type: 'PermittedAdmins',
                "class": 'html',
                settings: {}
              }
            }, {
              handle: 'questOrg',
              label: '@groupType:one:questorganization@',
              name: 'ancestorGroups.questorganization.group.label',
              filter: true,
              sort: true
            }, {
              handle: 'respondentFields',
              label: 'Respondent Fields',
              name: 'fields.field_1',
              filter: true,
              sort: true,
              renderAs: {
                type: 'ListRender',
                "class": 'html',
                settings: {
                  truncateSpace: true,
                  rightAlign: true,
                  values: [{
                    valuePath: 'fields.field_1',
                    prefix: '',
                    suffix: '',
                    ifValue: {
                      value: null,
                      display: ''
                    }
                  }, {
                    valuePath: 'fields.field_2',
                    prefix: '',
                    suffix: '',
                    ifValue: {
                      value: null,
                      display: ''
                    }
                  }, {
                    valuePath: 'fields.field_3',
                    prefix: '',
                    suffix: '',
                    ifValue: {
                      value: null,
                      display: ''
                    }
                  }, {
                    valuePath: 'fields.field_4',
                    prefix: '',
                    suffix: '',
                    ifValue: {
                      value: null,
                      display: ''
                    }
                  }, {
                    valuePath: 'fields.field_5',
                    prefix: '',
                    suffix: '',
                    ifValue: {
                      value: null,
                      display: ''
                    }
                  }]
                }
              }
            }, {
              handle: 'assignmentProgressCount',
              label: 'Respondent Count',
              name: 'assignmentProgressCount',
              filter: true,
              sort: true,
              className: 'text-center'
            }, {
              handle: 'createdDate',
              label: 'Created',
              name: 'group.createdDate',
              filter: true,
              filterSettings: {
                type: 'date'
              },
              sort: true
            }]
          },
          bottomTableLink: 'Show archived',
          bottomTable: {
            name: 'archived',
            rowKey: 'group.groupId',
            query: _questproject_tableArchived["default"],
            rowActions: [{
              action: 'unarchiveGroups',
              name: 'Unarchive Selected',
              title: 'Unarchive Selected'
            }, {
              action: 'deleteGroups',
              name: 'Delete Selected',
              title: 'Delete Selected'
            }],
            columns: [{
              handle: 'actions',
              label: 'Actions',
              name: 'actions',
              renderAs: {
                type: 'UnarchiveButton',
                settings: {
                  type: 'unarchive',
                  label: '',
                  withTooltip: false,
                  className: 'btn-xs btn-info',
                  nexusType: 'group',
                  typeString: '@groupType:one:questproject@'
                }
              }
            }, {
              handle: 'questProjectName',
              label: '@groupType:one:questproject@ Name',
              name: 'group.label',
              filter: true,
              sort: true
            }, {
              handle: 'questAdminCount',
              label: 'Permitted @role:many:questprojectadmin@',
              name: 'targetedByPawns.questprojectadminCount',
              filter: true,
              sort: true,
              className: 'text-center',
              renderAs: {
                type: 'PermittedAdmins',
                "class": 'html',
                settings: {}
              }
            }, {
              handle: 'questOrg',
              label: '@groupType:one:questorganization@',
              name: 'ancestorGroups.questorganization.group.label',
              filter: true,
              sort: true
            }, {
              handle: 'respondentFields',
              label: 'Respondent Fields',
              name: 'fields.field_1',
              filter: true,
              sort: true,
              renderAs: {
                type: 'ListRender',
                "class": 'html',
                settings: {
                  truncateSpace: true,
                  rightAlign: true,
                  values: [{
                    valuePath: 'fields.field_1',
                    prefix: '',
                    suffix: '',
                    ifValue: {
                      value: null,
                      display: ''
                    }
                  }, {
                    valuePath: 'fields.field_2',
                    prefix: '',
                    suffix: '',
                    ifValue: {
                      value: null,
                      display: ''
                    }
                  }, {
                    valuePath: 'fields.field_3',
                    prefix: '',
                    suffix: '',
                    ifValue: {
                      value: null,
                      display: ''
                    }
                  }, {
                    valuePath: 'fields.field_4',
                    prefix: '',
                    suffix: '',
                    ifValue: {
                      value: null,
                      display: ''
                    }
                  }, {
                    valuePath: 'fields.field_5',
                    prefix: '',
                    suffix: '',
                    ifValue: {
                      value: null,
                      display: ''
                    }
                  }]
                }
              }
            }, {
              handle: 'assignmentProgressCount',
              label: 'Respondent Count',
              name: 'assignmentProgressCount',
              filter: true,
              sort: true,
              className: 'text-center'
            }, {
              handle: 'createdDate',
              label: 'Created',
              name: 'group.createdDate',
              filter: true,
              filterSettings: {
                type: 'date'
              },
              sort: true
            }, {
              handle: 'archivedDate',
              label: 'Archived',
              name: 'group.archivedDate',
              filter: true,
              filterSettings: {
                type: 'date'
              },
              sort: true
            }]
          }
        }]
      }
    }
  }, {
    handle: 'admin_manage_questprojectadmins',
    label: '@role:many:questprojectadmin@',
    order: 1,
    contentConfig: {
      type: '@role:one:questprojectadmin@',
      nexusType: 'pawn',
      routes: {
        create: {
          name: 'api.nexus.pawn.store'
        },
        edit: {
          name: 'api.nexus.pawn.update',
          params: {
            pawn: 'pawn.pawnId',
            pawnHash: 'pawn.pawnHash'
          }
        },
        "delete": {
          name: 'api.nexus.pawn.destroy',
          params: {
            pawn: 'pawn.pawnId'
          }
        }
      },
      form: {
        handle: 'admin_manage_questprojectadmin_form',
        isUserForm: true,
        graphql: {
          edit: {
            create: {
              gql_query: _questproject_formCreate["default"]
            },
            gql_query: _questprojectadmin_formEdit["default"],
            requiredVariables: [{
              variable: 'pawnId',
              field: 'pawn.pawnId'
            }]
          }
        },
        fields: [{
          handle: 'questprojectadmin_questorg',
          reduxFieldHandle: 'group',
          order: 0,
          type: 'pawnField',
          validationSettings: {
            isRequired: true
          },
          displaySettings: {
            renderAs: 'table',
            label: '@groupType:one:questorganization@:',
            fieldProps: {
              selectionType: 'single',
              setValueNotArray: true,
              query: 'query { groups(as: uberadmin) { questorganizationList { group { groupId label} fields { level }}}}',
              dataPath: 'groups.questorganizationList',
              table: {
                props: {
                  name: 'admin_manage_org_admin_form_group',
                  rowKey: 'group.groupId',
                  saveState: true
                },
                columns: [{
                  name: 'group.label',
                  label: '@groupType:one:questorganization@',
                  filter: true,
                  sort: true
                }, {
                  name: 'fields.level',
                  label: 'Level',
                  filter: true,
                  sort: true
                }]
              }
            }
          },
          graphql: {
            dependsOn: null,
            edit: {
              valuePath: 'roles.questprojectadmin.ancestorGroups.questorganization.group.groupId',
              skipPawnCollectionProcessing: true
            }
          }
        }, {
          handle: 'username_questprojectadmin',
          reduxFieldHandle: 'username',
          disableOnEdit: true,
          order: 1,
          type: 'pawnDataField',
          validationSettings: {
            validationType: 'ascii',
            isRequired: true
          },
          displaySettings: {
            renderAs: 'input',
            label: 'Username:'
          },
          graphql: {
            dependsOn: null,
            edit: {
              valuePath: 'roles.questprojectadmin.user.username'
            }
          }
        }, {
          handle: 'firstname_questprojectadmin',
          reduxFieldHandle: 'first_name',
          order: 2,
          type: 'pawnDataField',
          validationSettings: {
            isRequired: true
          },
          displaySettings: {
            renderAs: 'input',
            label: 'First Name:'
          },
          graphql: {
            dependsOn: null,
            edit: {
              valuePath: 'roles.questprojectadmin.user.firstName'
            }
          }
        }, {
          handle: 'lastname_questprojectadmin',
          reduxFieldHandle: 'last_name',
          order: 3,
          type: 'pawnDataField',
          validationSettings: {
            isRequired: true
          },
          displaySettings: {
            renderAs: 'input',
            label: 'Last Name:'
          },
          graphql: {
            dependsOn: null,
            edit: {
              valuePath: 'roles.questprojectadmin.user.lastName'
            }
          }
        }, {
          handle: 'email_questprojectadmin',
          reduxFieldHandle: 'email',
          order: 4,
          type: 'pawnDataField',
          validationSettings: {
            validationType: 'email',
            isRequired: true
          },
          displaySettings: {
            renderAs: 'input',
            label: 'Email:'
          },
          graphql: {
            dependsOn: null,
            edit: {
              valuePath: 'roles.questprojectadmin.user.email'
            }
          }
        }, {
          handle: 'phone_questprojectadmin',
          reduxFieldHandle: 'phone',
          order: 5,
          type: 'pawnDataField',
          validationSettings: {
            isRequired: false
          },
          displaySettings: {
            renderAs: 'input',
            label: 'Phone:'
          },
          graphql: {
            dependsOn: null,
            edit: {
              valuePath: 'roles.questprojectadmin.user.phone'
            }
          }
        }, {
          handle: 'role_questprojectadmin',
          reduxFieldHandle: 'role',
          order: 6,
          type: 'pawnDataField',
          displaySettings: {
            renderAs: 'hidden',
            fieldProps: {
              initialValue: 'questprojectadmin'
            }
          }
        }]
      },
      tableTop: {
        handle: 'manage_questprojectadmin',
        saveState: true,
        views: [{
          handle: 'manage',
          title: 'Manage',
          table: {
            name: 'main',
            rowKey: 'pawn.pawnId',
            query: _questprojectadmin_tableMain["default"],
            rowActions: [{
              action: 'archivePawns',
              name: 'Archive Selected',
              title: 'Archive Selected'
            }, {
              action: 'deletePawns',
              name: 'Delete Selected',
              title: 'Delete Selected'
            }],
            columns: [{
              handle: 'actions',
              label: 'Actions',
              name: 'actions',
              renderAs: {
                type: 'RosteringButtons',
                "class": 'html',
                settings: {
                  buttons: [{
                    type: 'edit',
                    label: '',
                    className: 'btn-xs btn-success',
                    withTooltip: true,
                    tooltipText: 'Edit'
                  }, {
                    type: 'archive',
                    label: '',
                    className: 'btn-xs btn-primary',
                    withTooltip: true,
                    tooltipText: 'Archive'
                  }, {
                    type: 'delete',
                    label: '',
                    className: 'btn-xs btn-danger',
                    withTooltip: true,
                    tooltipText: 'Delete'
                  }, {
                    type: 'forgotPassword',
                    label: '',
                    className: 'btn-xs btn-danger',
                    withTooltip: true,
                    tooltipText: 'Forgot Password'
                  }]
                }
              }
            }, {
              handle: 'username',
              label: 'Username',
              name: 'user.username',
              filter: true,
              sort: true
            }, {
              handle: 'permissions',
              label: 'Permissions',
              name: 'designPawnPerm',
              className: 'text-center',
              renderAs: {
                type: 'Permissions',
                "class": 'html',
                settings: {
                  type: 'questProjectAdmin'
                }
              }
            }, {
              handle: 'projectPermissions',
              label: 'Accessible Projects',
              name: 'projectPerms',
              className: 'text-center',
              renderAs: {
                type: 'ProjectPermissions',
                "class": 'html',
                settings: {}
              }
            }, {
              handle: 'questOrg',
              label: '@groupType:one:questorganization@',
              name: 'ancestorGroups.questorganization.group.label',
              filter: true,
              sort: true
            }, {
              handle: 'first_name',
              label: 'First Name',
              name: 'user.firstName',
              filter: true,
              sort: true
            }, {
              handle: 'last_name',
              label: 'Last Name',
              name: 'user.lastName',
              filter: true,
              sort: true
            }, {
              handle: 'email',
              label: 'E-mail',
              name: 'user.email',
              filter: true,
              sort: true
            }, {
              handle: 'phone',
              label: 'Phone',
              name: 'user.phone',
              filter: true,
              sort: true
            }, {
              handle: 'lastLogin',
              label: 'Last Login',
              name: 'user.lastLoginDate',
              filter: true,
              sort: true,
              renderAs: {
                type: 'LastLogin',
                "class": 'html',
                settings: {
                  type: 'questmanage'
                }
              },
              filterSettings: {
                type: 'date'
              }
            }, {
              handle: 'createdAt',
              label: 'Created',
              name: 'pawn.createdDate',
              filter: true,
              filterSettings: {
                type: 'date'
              },
              sort: true
            }]
          },
          bottomTableLink: 'Show archived',
          bottomTable: {
            name: 'archived',
            rowKey: 'pawn.pawnId',
            query: _questprojectadmin_tableArchived["default"],
            rowActions: [{
              action: 'unarchivePawns',
              name: 'Unarchive Selected',
              title: 'Unarchive Selected'
            }, {
              action: 'deletePawns',
              name: 'Delete Selected',
              title: 'Delete Selected'
            }],
            columns: [{
              handle: 'actions',
              label: 'Actions',
              name: 'actions',
              renderAs: {
                type: 'UnarchiveButton',
                settings: {
                  type: 'unarchive',
                  label: '',
                  withTooltip: false,
                  className: 'btn-xs btn-info',
                  nexusType: 'pawn',
                  typeString: '@role:one:questprojectadmin@'
                }
              }
            }, {
              handle: 'username',
              label: 'Username',
              name: 'user.username',
              filter: true,
              sort: true
            }, {
              handle: 'projectPermissions',
              label: 'Accessible Projects',
              name: 'designPawnPerm',
              className: 'text-center',
              renderAs: {
                type: 'ProjectPermissions',
                "class": 'html',
                settings: {}
              }
            }, {
              handle: 'questOrg',
              label: '@groupType:one:questorganization@',
              name: 'ancestorGroups.questorganization.group.label',
              filter: true,
              sort: true
            }, {
              handle: 'first_name',
              label: 'First Name',
              name: 'user.firstName',
              filter: true,
              sort: true
            }, {
              handle: 'last_name',
              label: 'Last Name',
              name: 'user.lastName',
              filter: true,
              sort: true
            }, {
              handle: 'email',
              label: 'E-mail',
              name: 'user.email',
              filter: true,
              sort: true
            }, {
              handle: 'phone',
              label: 'Phone',
              name: 'user.phone',
              filter: true,
              sort: true
            }, {
              handle: 'lastLogin',
              label: 'Last Login',
              name: 'user.lastLoginDate',
              filter: true,
              filterSettings: {
                type: 'date'
              },
              sort: true
            }, {
              handle: 'createdDate',
              label: 'Created',
              name: 'pawn.createdDate',
              filter: true,
              filterSettings: {
                type: 'date'
              },
              sort: true
            }, {
              handle: 'archivedDate',
              label: 'Archived',
              name: 'pawn.archivedDate',
              filter: true,
              filterSettings: {
                type: 'date'
              },
              sort: true
            }]
          }
        }]
      }
    }
  }]
};